import { ApiClient } from "#/shared/api/client";
import { extractErrorMessage } from "#ce/apps/SpAdmin/shared/utils/extract-error-message";

class AssignSpecialtiesApi extends ApiClient {
  transform(data) {
    return data;
  }

  // Starts the background preview. Resolves to `{ token, status }`, or to the error
  // preview (`rows`, `summary`, `errors`) when the input is rejected with 422.
  async preview(previewUrl, formData) {
    try {
      return await this.post(previewUrl, formData);
    } catch (error) {
      // A 422 start still carries the rows/summary payload — surface it so
      // the confirm step can render the errors.
      if (Array.isArray(error?.data?.rows)) {
        return error.data;
      }

      throw new Error(extractErrorMessage(error));
    }
  }

  // Fetches the preview's status. Resolves to one of:
  //   - `{ status: "pending" | "expired" | "cancelled" }`
  //   - `{ status: "running", processed, total, estimated_seconds_remaining }`
  //   - `{ status: "ready", rows, summary, errors }`
  //   - `{ status: "failed", errors }`
  async previewStatus(statusUrl, token) {
    try {
      return await this.get(statusUrl, { token });
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }

  async cancelPreview(cancelUrl, token) {
    try {
      return await this.post(cancelUrl, { token });
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }

  async process(processUrl, payload) {
    try {
      return await this.post(processUrl, payload);
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  }
}

let api;

export function createAssignSpecialtiesApi() {
  api ??= new AssignSpecialtiesApi();

  return api;
}
